import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaTelegram, 
  FaTwitter, 
  FaLinkedin, 
  FaGithub,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt 
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-800 text-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/images/boulevard logo.png" 
                alt="RideEase Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-display font-bold">Boulevard</span>
            </div>
            <p className="text-secondary-300 text-sm">
              The only ride-sharing platform with 0% platform fees. Community service by iautenticai company. 
              Riders set prices, drivers keep 100%. No corporate middleman.
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              <a 
                href="https://t.me/Rideatease_bot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-300 hover:text-blue-400 transition-colors"
                title="Rider Bot"
              >
                <FaTelegram size={20} />
              </a>
              <a 
                href="https://t.me/Rideeasedriver_bot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-300 hover:text-green-400 transition-colors"
                title="Driver Bot"
              >
                <FaTelegram size={20} />
              </a>
              <a 
                href="https://twitter.com/boulevard" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-300 hover:text-accent-400 transition-colors"
              >
                <FaTwitter size={20} />
              </a>
              <a 
                href="https://linkedin.com/company/boulevard" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-300 hover:text-accent-400 transition-colors"
              >
                <FaLinkedin size={20} />
              </a>
              <a 
                href="https://github.com/boulevard" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-secondary-300 hover:text-accent-400 transition-colors"
              >
                <FaGithub size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-accent-300">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/docs" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-accent-300">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="/cookies" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Cookie Policy
                </a>
              </li>
              <li>
                <a href="/security" className="text-secondary-300 hover:text-accent-400 transition-colors">
                  Security
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-accent-300">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <FaTelegram className="text-accent-400" />
                <span className="text-secondary-300 text-sm">@Rideatease_bot (Riders)</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaTelegram className="text-accent-400" />
                <span className="text-secondary-300 text-sm">@Rideeasedriver_bot (Drivers)</span>
              </li>
              <li className="flex items-start space-x-3">
                <FaEnvelope className="text-accent-400 mt-1" />
                <span className="text-secondary-300 text-sm">
                  Community Service by<br />
                  iautenticai company
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-accent-600 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-secondary-300 text-sm">
              © {currentYear} Boulevard by iautenticai. Community service - forever free.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <span className="text-secondary-300 text-sm">Made with ❤️ to end corporate exploitation</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
